<template>
  <div>
    <video-table />
  </div>
</template>

<script>
import VideoTable from '../components/dashboard/VideoTable.vue';
export default {
  components: { 'video-table': VideoTable },
};
</script>
